
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL as url } from '../../variables';

import { MdDelete, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner, CloseButton } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import { BsFillEyeFill } from 'react-icons/bs';
import ModalQuestao from '../ReusableComponents/ModalQuestao';

import PDF_IMAGE from '../../assets/images/pdf.png';
import { FaSave } from 'react-icons/fa';
import ModalProva from './ModalProva';

class CriarRecurso extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/recursos',
            loading_screen: true,
            roles: [],
            name: '',
            descricao: '',
            fundamentacao: '',
            pedido_realizado:'',

            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,

            fim: moment().add(1, 'day'),
            hora_inicio: moment(),
            hora_fim: moment().add(1, 'hour'),
            inicio: moment(),
            categorias: [],
            professores: [],
            pagination: {
                page: 1,
                last_page: 1,
            },
            categoria_search: '',
            show_autocomplete_categoria: false,
            loading_search_categoria: false,
            categorias_select: {},
            showModal: false,
            categoriaSelect: null,
            provas: [],
            processo_enunciado: '',
            categorias: [],
            loading_search_categoria: false,
            questao_id: '',
            loading_search_questao: false,
            show_autocomplete_questao: false,
            questao_enunciado: '',
            questoes: [],
            questaoSelect: null,
            categoria: {},
            files: [],
            files_images: [],
            numero_inscricao:'',
            prova_id:''
        };

        this.inputRef = React.createRef();


    }



    salvar(e) {
        e.preventDefault();
        this.setState({ loading_save: true, msgErro: '' });
        let form = new FormData();
        form.append('name',this.state.name);
        form.append('description',this.state.descricao);
        form.append('fundamentacao',this.state.fundamentacao);
        form.append('pedido_realizado',this.state.pedido_realizado);

        if(this.state.questaoSelect!=null){
            form.append('questao_id',this.state.questaoSelect?.id);
        }
        form.append('categoria_id',this.state.questaoSelect?.categoria_id ?? '');
        form.append('prova_id',this.state.prova_id);
        form.append('processo_id',this.props.processo.id);

        // form.append('numero_inscricao_candidato',this.props.user.numero_inscricao);
        // form.append('fim',this.state.fim.format('DD/MM/YYYY'));
        // form.append('hora_fim',this.state.hora_fim.format('HH:mm'));

        this.state.files.map((file,id)=>{
            form.append('files[]',file);
        })









        // if (Object.values(this.state.categorias_select).length == 0) {
        //     this.setState({ loading_save: false, msgErro: 'A recurso deve ter pelo menos uma categoria selecionada' });
        //     return;
        // }

        fetch(`${url}api/store_recurso`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                // 'Content-type': 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    window.scrollTo(500, 0);

                    this.setState({ loading_save: false, msgErro: erro });
                }
                else {

                    this.setState({ loading_save: false, redirect: true });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
            });
    }


    componentDidMount() {
        this.get_data(this.state.processo_enunciado);
    }


    get_data(search) {

        if (this.state.loading_q == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${url}api/get_data_recurso/${this.props.processo.id}?search=${search}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false,
                        provas: resp.provas
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }


    get_categorias(processo_id) {

        if (this.state.loading_search_categoria == false) {
            this.setState({ loading_search_categoria: true });
        }
        fetch(`${url}api/faculdade/get_categorias_processo/${processo_id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ loading_search_categoria: true,categorias:[] });
                    this.get_categorias();
                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_search_categoria: false,
                        categorias: resp.categorias
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.get_categorias();
                // this.setState({ loading_search_categoria: false,categorias:[] });
                console.log(err);


            }

        })
            .catch((err) => {
                // this.setState({ loading_search_categoria: false,categorias:[] });
                this.get_categorias();

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }


    get_questoes(search) {

        if (this.state.loading_search_questao == false) {
            this.setState({ loading_search_questao: true });
        }
        fetch(`${url}api/faculdade/get_questoes_processo/${this.state.categoria_id}/${this.state.processo_id}?search=${search}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    // this.setState({ loading_search_categoria: true,categorias:[] });
                    this.get_questoes();
                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_search_questao: false,
                        questoes: resp.questoes
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.get_questoes();
                // this.setState({ loading_search_categoria: false,categorias:[] });
                console.log(err);


            }

        })
            .catch((err) => {
                // this.setState({ loading_search_categoria: false,categorias:[] });
                this.get_questoes();

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }





    change_tipo(event) {
        this.setState({ tipo: event.target.value });
    }

    select_categoria(item) {
        let categorias = { ...this.state.categorias_select };
        categorias[item.id] = item;
        this.setState({ categoria_search: '', categorias_select: categorias })
    }

    select_questao(item) {
        this.setState({ questao_enunciado: '', show_autocomplete_questao: false, questaoSelect: item });
    }

    render() {
        let index_questao=0;
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card" style={{ overflow: 'visible' }}>


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Cadastrar Recurso de Questão</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Cadastre um recurso de uma questão do seu sistema</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0}}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}

                                <ModalQuestao showModal={this.state.showModal} setShowModal={(e) => this.setState({ showModal: e })} questao={this.state.questaoSelect} />


                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    

                                    <InputGroup>
                                        <div className="w-100 flex fdcolumn flex1 margin-bottom" style={{ position: 'relative' }}>
                                            <Form.Label>Prova <Attention /></Form.Label>
                                            <select className="form-select "
                                                disabled={this.state.loading_search_categoria}
                                                onChange={(e) => {

                                                    this.setState({ prova_id: e.target.value,questaoSelect:null,questao_id:'' }, () => {
                                                       
                                                    });
                                                }} value={this.state.prova_id}>
                                                <option value="">Selecione uma prova</option>
                                                {(this.state.provas && this.state.provas.length != 0) && this.state.provas.map((value, index) => (
                                                    <option
                                                        key={index}
                                                        value={value["prova"].id}
                                                    >{value["prova"].name} - {value['questoes'].map((item)=>{
                                                        if(item.type_questao=='conjunto'){
                                                            return item.questoes.length
                                                        }
                                                        return 1
                                                    }).reduce((accumulator, current) => accumulator + current, 0) } Questões</option>
                                                ))}
                                            </select>
                                            {this.state.loading_search_categoria == true && <div style={{ position: 'absolute', right: 30, top: 40 }}>
                                                <div className="spinner-border spinner-border-sm text-primary" role="status"  >
                                                </div>
                                            </div>}
                                        </div>
                                    </InputGroup>

                                    {this.state.prova_id != '' && <InputGroup>
                                        {/* <ModalProva model showModal={this.state.showModalProva ?? false} setShowModal={(e) => { this.setState({showModalProva:e})}} provaSelect={{respostas:'{}'}} prova_name={this.state.provas.filter((item)=>item.prova.id==this.state.prova_id)[0]?.prova?.name} questoes={this.state.provas.filter((item)=>item.prova.id==this.state.prova_id)[0]?.questoes ?? null} />
                                        <span className="btn btn-info btn-sm waves-effect waves-light"
                                        onClick={()=>{
                                            this.setState({showModalProva:true})
                                        }}
                                        style={{ width: 'auto',textTransform:'uppercase',marginBottom:10 }}>Ver prova selecionada</span> */}

                                        <div className="w-100 flex fdcolumn flex1 margin-bottom" style={{ position: 'relative' }}>
                                            <Form.Label>Questão<Attention /></Form.Label>
                                            <select
                                                disabled={this.state.loading_search_questao}

                                                className="form-select " onChange={(e) => {

                                                    let questaoSelect=null;
                                                    if(e.target.value!=''){
                                                        this.state.provas.filter((item)=>item.prova.id==this.state.prova_id)[0].questoes.map((value, index)=>{
                                                            if(value.type_questao=='conjunto'){
                                                                value.questoes.map((item2,index2)=>{
                                                                    if(item2.id==e.target.value){
                                                                        questaoSelect=item2;
                                                                    }
                                                                })

                                                            }
                                                            else if(value.id==e.target.value){
                                                                questaoSelect=value;
                                                            }
                                                        })
                                                    }

                                                    this.setState({ questao_id: e.target.value,questaoSelect }, () => {
                                                        
                                                    });
                                                }} value={this.state.questao_id}>
                                                <option value="">Selecione uma questão</option>
                                                {(this.state.provas && this.state.provas.length != 0) && this.state.provas.filter((item)=>item.prova.id==this.state.prova_id)[0].questoes.map((value, index) => {
                                                    if(value.type_questao=='conjunto'){
                                                        return value.questoes.map((item2,index2)=>{
                                                            index_questao++;
                                                            return <option
                                                                key={index_questao}
                                                                value={item2["id"]}
                                                            >{index_questao}) {item2["text_questao"]}</option>
                                                            })
                                                    }
                                                    index_questao++;

                                                    return(
                                                        <option
                                                            key={index_questao}
                                                            value={value["id"]}
                                                        >{index_questao}) {value["text_questao"]}</option>
                                                )
                                                })}
                                            </select>

                                        </div>
                                    </InputGroup>}


                                   

                                    {this.state.questaoSelect != null && <InputGroup>

                                        <div className="w-100 flex fdcolumn flex1 margin-bottom ">
                                            <Form.Label >Questão selecionada:</Form.Label>

                                            <div className="table-rep-plugin">
                                                <div className="table-responsive mb-0" data-pattern="priority-columns">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>


                                                                <th>Enunciado</th>
                                                                <th>Disciplina</th>

                                                                <th>Tipo de questão</th>

                                                                <th data-priority="3">Ações</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                            {this.state.questaoSelect != null &&
                                                                <tr>

                                                                    <td ><p className='text_overflow mb-0'>{this.state.questaoSelect.text_questao}</p></td>
                                                                    <td >{this.state.questaoSelect.categoria.name}</td>
                                                                    <td ><p className='mb-0'>{this.state.questaoSelect.type_questao == 'conjunto' ? ('Conjunto de questões\n' + this.state.questaoSelect.questoes.length + (this.state.questaoSelect.questoes.length == 1 ? ' questão' : ' questões')) :
                                                                        (this.state.questaoSelect.type_questao == 'simples' ? 'Questão única' : 'Questão dissertativa')}</p></td>

                                                                    <td >
                                                                        <div style={{ minWidth: 90,display:'flex',height:'100%' }}>

                                                                        <span
                                                                            onClick={() => {
                                                                                this.setState({ questaoSelect: this.state.questaoSelect, showModal: true });
                                                                            }}
                                                                            className="d-flex align-items-center justify-content-center bg-warning icon mr-2"
                                                                            style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: 5,padding:10,cursor:'pointer' }}
                                                                            title="Gerenciar aula"
                                                                        >
                                                                            <BsFillEyeFill size={17} color="white" />
                                                                        </span>
                                                                        <span
                                                                            onClick={(e) => {
                                                                                this.setState({ questaoSelect: null });
                                                                            }}
                                                                            className="d-flex align-items-center justify-content-center bg-danger icon"
                                                                            style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: 5,padding:10,cursor:'pointer' }}
                                                                            title="Deletar texto"
                                                                        >
                                                                            <MdDelete size={17} color="white" />
                                                                        </span>
                                                                        </div>

                                                                    </td>

                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {this.state.questaoSelect == null && <div className="row w-100">
                                                <div className="col-12">
                                                    <p style={{ textAlign: 'center' }}>Nenhuma questão selecionada</p>

                                                </div>
                                            </div>}
                                            {/* <div>
                                                <p style={{ marginBottom: 0 }}><b>Nome do responsável: </b> {this.state.questaoSelect.user.name}</p>
                                                <p><b>E-mail do responsável: </b> {this.state.questaoSelect.user.email}</p>

                                            </div> */}

                                        </div>
                                    </InputGroup>}


                                    <InputGroup>

                                        <div className="w-100 flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Descrição dos fatos <Attention/></Form.Label>
                                            <Input
                                                placeholder="Descrição dos fatos"
                                                value={this.state.descricao}
                                                onChange={(e) => this.setState({ descricao: e.target.value })}
                                                required
                                                as="textarea"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="w-100 flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Fundamentação do pedido <Attention/></Form.Label>
                                            <Input
                                                placeholder="Fundamentação do pedido"
                                                value={this.state.fundamentacao}
                                                onChange={(e) => this.setState({ fundamentacao: e.target.value })}
                                                required
                                                as="textarea"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="w-100 flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Pedido realizado <Attention/></Form.Label>
                                            <Input
                                                placeholder="Pedido realizado"
                                                value={this.state.pedido_realizado}
                                                onChange={(e) => this.setState({ pedido_realizado: e.target.value })}
                                                required
                                                as="textarea"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>
                                       

                                        <div className="w-100 margin-bottom ">
                                            <Form.Label >Imagens/arquivos do recurso (Máximo 10 arquivos)</Form.Label>
                                            <Input
                                                style={{width:'100%'}}
                                                type="file"
                                                accept="image/*,application/pdf"
                                                multiple
                                                onChange={(e) => {
                                                    this.setState({ loading_files: true });
                                                    let files = [...e.target.files];
                                                    let files_images = [...this.state.files_images];

                                                    console.log(files);
                                                    // SetInputValue(file);

                                                    // PreviewImage(file);
                                                    // (props.ImageChange && props.ImageChange(file));
                                                    if (files && FileReader) {

                                                        files.map((file, id) => {
                                                            files_images.push(URL.createObjectURL(file));

                                                        })
                                                        let files_actual = [...this.state.files, ...files];
                                                        this.setState({ loading_files: false, files: files_actual.filter((item,id)=>id<10), files_images:files_images.filter((item,id)=>id<10) });



                                                    }
                                                    this.inputRef.current.value = '';
                                                }}
                                                ref={this.inputRef}
                                            />
                                            <div className='row' style={{ marginRight: 0, marginLeft: 0 }}>
                                                {this.state.files.map((item, id) => (
                                                    <div key={id} style={{ width: 100, marginRight: 10, marginTop: 10,position:'relative' }}>
                                                        {!item.name.includes('.pdf') && <img
                                                            src={this.state.files_images[id]}
                                                            style={{ height: 75, width: 100, objectFit: 'contain' }}
                                                        />}
                                                        {item.name.includes('.pdf') && <img
                                                            src={PDF_IMAGE}
                                                            style={{ height: 75, width: 100, objectFit: 'contain' }}
                                                        />}
                                                        <div style={{ width: 100 }}>
                                                            <p style={{ marginBottom: 0, textAlign: 'center', marginTop: 5, fontSize: 11 }}>{item.name}</p>
                                                        </div>
                                                        <CloseButton
                                                            style={{background:'rgba(0,0,0,0.5)',position:'absolute',top:-5,right:-5,width:20,height:20,backgroundSize:'auto',fontSize:16,padding:1,borderRadius:100}}
                                                            id="remove-button"
                                                            size="small"
                                                            onClick={() => {
                                                                let files = this.state.files.filter((item2,id2)=>id!=id2);

                                                                let files_images = this.state.files_images.filter((item2,id2)=>id!=id2);

                                                                this.setState({files,files_images});

                                                            }}
                                                        >
                                                           
                                                        </CloseButton>
                                                    </div>
                                                ))}

                                            </div>

                                        </div>
                                    </InputGroup>




                                   

                                    {this.state.loading_save == false && <div className="w-100  d-flex justify-content-between mt-2">
                                        {/* <Link to={`/accounts/list`}>
                                    <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                                </Link> */}
                                        <DefaultButton
                                            bg="secondary"
                                            text="Voltar"
                                            icon={<RiArrowGoBackLine />}
                                            to="/recursos"
                                        />
                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                                    {this.state.loading ? <Spinner /> : ""}
                                    Registrar usuário
                                </Button> */}
                                        <DefaultButton
                                            type="submit"
                                            bg="confirm"
                                            text="Salvar recurso"
                                            icon={<FaSave style={{marginRight:5}} color='white' />}
                                            disabled={this.state.loading_image == true}
                                            loadingtext="Salvando recurso"
                                            loading={this.state.loading_save}
                                        />
                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1" >
                                        <div className="spinner-border text-primary" role="status"  >
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status"  >
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div >
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        processo: state.AppReducer.processo,
        faculdade: state.AppReducer.faculdade,
    }
);

export default connect(mapsStateToProps, { logout })(CriarRecurso);


